module.exports = __webpack_public_path__ + "static/media/trocafone-reparos -color-desktop.6eaee030.svg";